import { render, staticRenderFns } from "./meta_data.vue?vue&type=template&id=33a2dc93&"
import script from "./meta_data.vue?vue&type=script&lang=js&"
export * from "./meta_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a2dc93')) {
      api.createRecord('33a2dc93', component.options)
    } else {
      api.reload('33a2dc93', component.options)
    }
    module.hot.accept("./meta_data.vue?vue&type=template&id=33a2dc93&", function () {
      api.rerender('33a2dc93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/tabs/meta_data.vue"
export default component.exports